import HeaderSection from "../HeaderSection";
import React from "react"
import MySkills from "../MySkills";
import AboutMe from "../AboutMe";
import MyPortiflio from "../MyPortiflio";
import ContactMe from "../Contact";
import Footer from "../Footer";

export default function Home(){
    return (
        <>
         <HeaderSection/>
         <MySkills/>
         <AboutMe/>
         <MyPortiflio/>
         <ContactMe/>
         <Footer/>
        </>
    )
}